import Joi from '@hapi/joi';

const isoDateRegex =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;

const routesSchema = Joi.object({
  routeId: Joi.string().required(),
  routeLockedBy: Joi.string().allow(null, '').required(),
  checksum: Joi.any().allow(null).required(),
  routeCode: Joi.string().allow('').required(),
  driverName: Joi.string().allow(null, '').optional(),
  driverCode: Joi.string().allow(null, '').optional(),
  odfRouteOwner: Joi.string().allow(null, '').optional(),
  totalOpenRequests: Joi.number().required(),
  totalStops: Joi.number().required(),
  totalParcels: Joi.number().required(),
  totalMiles: Joi.number().required(),
  collections: Joi.number().allow(null),
  opportunityTime: Joi.number().required(),
  postcodeExceptions: Joi.number().required(),
  serviceExceptions: Joi.number().required(),
  dutyTimeExceptions: Joi.number().required(),
  legalDutyExceptions: Joi.number().required(),
  rangeExceptions: Joi.number().required(),
  routeStatusDescription: Joi.string().required(),
  routeStatus: Joi.number().required(),
  loadingPercentage: Joi.number().allow(null).optional(),
  lowLoadRate: Joi.bool().allow(null).optional(),
  dutyStartTime: Joi.string().allow('').required(),
  dutyEndTime: Joi.string().allow('').required(),
  totalDutyTime: Joi.string().allow('').required(),
  departTime: Joi.string().allow('').required(),
  returnTime: Joi.string().allow('').required(),
  vehicleType: Joi.string().allow('').optional(),
  vehicleTypeCategory: Joi.string().allow('').optional(),
  electricVehicle: Joi.bool().optional(),
  totalWeight: Joi.number().required(),
  vehicleOverweight: Joi.bool().required(),
  scheduleRequired: Joi.bool().allow(null).optional(),
  stopStats: Joi.object({
    totalSmalls: Joi.number().required(),
    totalNonCompatibles: Joi.number().required(),
    totalBulk: Joi.number().required(),
    totalBy1030: Joi.number().required(),
    totalBy12: Joi.number().required(),
    totalPrecise: Joi.number().required(),
    totalAfternoon: Joi.number().required(),
    totalEvening: Joi.number().required(),
    totalPerishable: Joi.number().required(),
    totalWeekend: Joi.number().allow(null),
  }).required(),
  parcelStats: Joi.object({
    totalSmalls: Joi.number().required(),
    totalNonCompatibles: Joi.number().required(),
    totalBulk: Joi.number().required(),
    totalBy1030: Joi.number().required(),
    totalBy12: Joi.number().required(),
    totalPrecise: Joi.number().required(),
    totalAfternoon: Joi.number().required(),
    totalEvening: Joi.number().required(),
    totalPerishable: Joi.number().required(),
    totalWeekend: Joi.number().allow(null),
  }).required(),
  totalRouteParcels: Joi.number().required(),
  totalCollectionStops: Joi.number().required(),
  totalForecastParcels: Joi.number().required(),
  totalForecastStops: Joi.number().required(),
  totalOFDParcels: Joi.number().required(),
  totalScanTime: Joi.number().allow(null).optional(),
  routeDownloadTime: Joi.alternatives()
    .try(Joi.string().pattern(isoDateRegex), Joi.valid(null))
    .optional(),
  firstParcelScanTime: Joi.alternatives()
    .try(Joi.string().pattern(isoDateRegex), Joi.valid(null))
    .optional(),
  routeAuthorisedTime: Joi.alternatives()
    .try(Joi.string().pattern(isoDateRegex), Joi.valid(null))
    .optional(),
  targetDepartureTime: Joi.alternatives()
    .try(Joi.string().pattern(isoDateRegex), Joi.valid(null))
    .optional(),
  targetLoadRate: Joi.string().allow(null).optional(),
  actualLoadRate: Joi.number().allow(null).optional(),
  exceededLoadTime: Joi.bool().allow(null).optional(),
  defaultRoute: Joi.bool().optional(),
  sectionCode: Joi.number().optional().allow(null),
  transitStatus: Joi.object({
    cadScanned: Joi.number().required(),
    inTransit: Joi.number().required(),
    missing: Joi.number().required(),
  }),
  routeExceededScanTime: Joi.bool().allow(null).optional(),
  returnToDepotLegalException: Joi.bool().allow(null).optional(),
  sectionRoute: Joi.bool().allow(null).required(),
  choiceRoute: Joi.bool().allow(null).required(),
});

export const depotStatsSchema = Joi.object({
  totalRoutes: Joi.number().allow(null),
  stops: Joi.number().allow(null),
  parcels: Joi.number().allow(null),
  collections: Joi.number().allow(null),
  totalStops: Joi.number().allow(null),
  totalParcels: Joi.number().allow(null),
  totalCollections: Joi.number().allow(null),
  totalRouteExceptions: Joi.number().allow(null),
  totalExceptions: Joi.number().allow(null),
  totalDepartedRoutes: Joi.number().allow(null),
  totalOpenRequests: Joi.number().allow(null),
  departedRoutePercentage: Joi.number().allow(null),
  stopsPerRoute: Joi.number().allow(null),
  totalParcelsOfd: Joi.number().allow(null),
  averageScanTime: Joi.number().allow(null),
  averageDutyTime: Joi.number().allow(null),
  averageOpportunityTime: Joi.number().allow(null),
  totalRoutesExceededScanTime: Joi.number().allow(null),
});

const schema = Joi.object({
  routes: Joi.array().items(routesSchema).required(),
  depotStats: depotStatsSchema.required(),
});

export default schema;
